import React from "react"
import ShareButtons from "components/styled/theme-social-share-buttons"
import Breadcrumbs from "components/styled/theme-breadcrumbs"
import { GatsbyImage } from "gatsby-plugin-image"
import PropTypes from "prop-types"
import styled from "styled-components"
import PostContent from "components/styled/theme-post-content"
import Date from "components/styled/theme-post-date"
import { trailingSlashIt } from "@bufox/js-utils"

const MainContent = props => {
  const {
    breadcrumbs,
    className,
    content,
    date,
    image,
    location,
    siteUrl,
    socialNetworksShare,
    title,
  } = props
  return (
    <main className={className}>
      <article>
        <div className="content-heading">
          <div className="inner-content-heading">
            <div className="background-image-container">
              {image?.localFile?.childImageSharp?.gatsbyImageData ? (
                <GatsbyImage
                  className="background-image"
                  image={image.localFile.childImageSharp.gatsbyImageData}
                  alt={image.altText ? image.altText : title ? title : ""}
                ></GatsbyImage>
              ) : (
                <div className="no-image-background"></div>
              )}
            </div>
            <div className="main-title-container dry-container">
              {breadcrumbs ? (
                <Breadcrumbs
                  breadcrumbs={breadcrumbs.breadcrumbs}
                  className="breadcrumbs"
                  currentTitle={title}
                  removeLastLink={breadcrumbs.removeLastLink}
                />
              ) : null}
              <h1 className="main-title">{title}</h1>
              {date ? (
                <Date
                  dateGmt={date.dateGmt}
                  modifiedGmt={date.modifiedGmt}
                  locale={date.locale}
                ></Date>
              ) : null}
            </div>
          </div>
          {socialNetworksShare?.enableSocialNetworksShare && (
            <ShareButtons
              socialNetworks={socialNetworksShare.enabledSocialNetworks}
              pageUrl={
                trailingSlashIt(siteUrl) + trailingSlashIt(location.pathname)
              }
            ></ShareButtons>
          )}
        </div>
        <PostContent
          className={`${className}-content single-content dry-container post-content`}
        >
          {content}
        </PostContent>
      </article>
    </main>
  )
}

MainContent.propTypes = {
  breadcrumbs: PropTypes.object,
  className: PropTypes.string,
  content: PropTypes.string,
  date: PropTypes.object,
  image: PropTypes.object,
  location: PropTypes.object,
  siteUrl: PropTypes.string,
  socialNetworksShare: PropTypes.object,
  title: PropTypes.string,
}

MainContent.defaultProps = {
  shareButtons: ["facebook", "twitter", "pinterest"],
}

const StyledMainContent = styled(MainContent)`
  .content-heading {
    position: relative;
    width: 100%;
    padding-bottom: 0;
    margin-bottom: 4rem;
  }
  .inner-content-heading {
    position: relative;
    height: 24rem;
  }

  .background-image-container {
    position: absolute;
    z-index: 0;
    width: 100%;
    height: 100%;
  }

  .background-image {
    width: 100%;
    height: 100%;
  }

  .no-image-background {
    background-image: linear-gradient(
      to bottom right,
      var(--secondary),
      var(--tertiary, rgba(255, 255, 255, 0))
    );
    height: 24rem;
  }

  .main-title-container {
    position: absolute;
    bottom: 0px;
    left: 0px;
    right: 0px;
    z-index: 10;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 91.666667%;
    padding: 1rem;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    background: linear-gradient(
      180deg,
      var(--transparent-light) 0%,
      var(--light) 100%
    );
  }

  .breadcrumbs {
    margin-top: 2rem;
    margin-bottom: 0.75rem;
  }

  .main-title {
    margin-top: 2rem;
    margin-bottom: 2rem;
    font-size: 1.5rem;
    line-height: 2rem;
    text-transform: uppercase;
  }

  .single-content {
    position: relative;
    padding-left: 2rem;
    padding-right: 2rem;
    padding-top: 4rem;
    margin-top: 4rem;
    margin-bottom: 4rem;
    &:before {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
      width: 80%;
      height: 4px;
      background: var(--secondary);
      content: "";
    }
    .ad-slot-wpc {
      margin-left: -2rem;
      margin-right: -2rem;
      margin-top: 2rem;
      margin-bottom: 2rem;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`

export default StyledMainContent
export { MainContent }
